import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { NAV_LINKS, OFFICE, SERVICES } from "@/lib/site";
import LogoMark from "@/components/LogoMark";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="relative border-t border-white/10 bg-ink-950">
      <div className="mx-auto max-w-[1400px] px-6 lg:px-10">
        {/* CTA band */}
        <div className="grid gap-8 border-b border-white/10 py-16 md:grid-cols-2 md:items-end">
          <div>
            <span className="overline text-cyber">Let&apos;s build</span>
            <h2 className="mt-4 font-display text-4xl font-semibold leading-none tracking-tighter text-white sm:text-5xl lg:text-6xl">
              Ready to close<br />the loop?
            </h2>
          </div>
          <div className="md:justify-self-end">
            <Link
              to="/contact"
              data-testid="footer-cta"
              className="group inline-flex items-center gap-3 rounded-full bg-cyber px-7 py-4 font-body text-sm font-medium text-ink-950 transition-colors duration-300 hover:bg-white"
            >
              Start a conversation
              <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1" />
            </Link>
          </div>
        </div>

        {/* Columns */}
        <div className="grid gap-10 py-16 md:grid-cols-4">
          <div className="md:col-span-1">
            <div className="flex items-center gap-2.5">
              <LogoMark className="h-7 w-7 text-white" />
              <span className="font-display text-base font-semibold tracking-tight text-white">
                Core Loop Tech
              </span>
            </div>
            <p className="mt-4 max-w-xs font-body text-sm leading-relaxed text-white/45">
              Engineering intelligent systems, secure networks and clean data loops from Hong Kong to the world.
            </p>
          </div>

          <div>
            <h4 className="overline text-white/40">Navigate</h4>
            <ul className="mt-5 space-y-3">
              {NAV_LINKS.map((l) => (
                <li key={l.to}>
                  <Link to={l.to} className="font-body text-sm text-white/60 transition-colors duration-300 hover:text-cyber">
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="overline text-white/40">Capabilities</h4>
            <ul className="mt-5 space-y-3">
              {SERVICES.map((s) => (
                <li key={s.key}>
                  <Link to="/services" className="font-body text-sm text-white/60 transition-colors duration-300 hover:text-cyber">
                    {s.title}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="overline text-white/40">Studio</h4>
            <address className="mt-5 space-y-1 font-body text-sm not-italic leading-relaxed text-white/60">
              {OFFICE.lines.map((line) => (
                <div key={line}>{line}</div>
              ))}
            </address>
            <a
              href={`mailto:${OFFICE.email}`}
              className="mt-4 inline-block font-mono text-sm text-cyber transition-colors duration-300 hover:text-white"
            >
              {OFFICE.email}
            </a>
          </div>
        </div>

        <div className="flex flex-col gap-3 border-t border-white/10 py-8 sm:flex-row sm:items-center sm:justify-between">
          <p className="font-mono text-xs text-white/35">© {new Date().getFullYear()} Core Loop Tech — thecorelooptech.com</p>
          <p className="font-mono text-xs text-white/35">Kowloon · Hong Kong SAR</p>
        </div>
      </div>
    </footer>
  );
}
